let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1BEaf")).then(() => parcelRequire('cf5Cc'));